module.exports = __webpack_public_path__ + "static/media/2-_DSC8551.ec8f4bbc.jpg";